import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { DefaultFilter } from './default-filter.interface';
import { DefaultFilterService } from './default-filter.service';

const service = new DefaultFilterService();

export interface DefaultFilterState {}

const DefaultFilterStore: Module<DefaultFilterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getDefaultFilter(context, teamId: number) {
         const response = await service.getDefaultFilter(teamId);
         return response.data;
      },

      async postDefaultFilter(context, { teamId, defaultFilters }: { teamId: number; defaultFilters: Array<DefaultFilter> }) {
         const response = await service.postDefaultFilter(teamId, defaultFilters);
         return response;
      },

      async deleteDefaultFilter(context, teamId: number) {
         const response = await service.deleteDefaultFilter(teamId);
         return response;
      },
   },
};

export default DefaultFilterStore;
